import { render, staticRenderFns } from "./PagamentoNotaFiscalDetalhes.vue?vue&type=template&id=97ec0c20"
import script from "./PagamentoNotaFiscalDetalhes.vue?vue&type=script&lang=js"
export * from "./PagamentoNotaFiscalDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports